import React, { useState } from 'react';
import './Kontakt.css';
import zdjecieKontakt from '../assets/pictures/sandra-kanapa.webp';
import Faq from '../components/FAQ';

export default function Kontakt() {
  const [showPolicy, setShowPolicy] = useState(false);

  return (
    <>
      <div className="kontakt-wrapper">
        <div className="kontakt-page">
          <header className="kontakt-header">
            <h2>SANDRA SIUDMIAK</h2>
            <h3>SKONTAKTUJ SIĘ ZE MNĄ !</h3>
            <p className="contact-info">
              <a href="mailto:kontakt@lumi-studio.pl">studio.piekne.wnetrza@gmail.com</a>
            </p>
            <p className="intro">
              Jeśli masz pytania dotyczące moich usług projektowych, chcesz porozmawiać o koncepcji architektonicznej
              lub rozpocząć współpracę – zapraszam do kontaktu.
              Z przyjemnością doradzę i odpowiem na wszystkie pytania. Wypełnij poniższy formularz,
              a odezwę się do Ciebie tak szybko, jak to możliwe.
            </p>
          </header>

          <form className="kontakt-form">
            <label>Imię i nazwisko
              <input type="text" name="name" required />
            </label>

            <label>E-mail
              <input type="email" name="email" required />
            </label>

            <label>Wiadomość/zapytanie
              <textarea name="message" rows="5" required />
            </label>

            <label className="checkbox">
              <input type="checkbox" name="privacy" required />
              Przeczytałem/am i akceptuję
              <button
                type="button"
                className="privacy-link"
                onClick={() => setShowPolicy(true)}
              >
                politykę prywatności
              </button>
            </label>

            <button className="btn" type="submit">Wyślij zapytanie</button>
          </form>
        </div>

        <div className="kontakt-image">
          <img src={zdjecieKontakt} alt="Sandra Siudmiak" />
        </div>
      </div>

      <div>
        <Faq />
      </div>

      {/* MODAL POLITYKI PRYWATNOŚCI */}
      {showPolicy && (
        <div className="policy-modal-overlay" onClick={() => setShowPolicy(false)}>
          <div className="policy-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Polityka prywatności</h3>

            <p>
              Administratorem danych jest Sandra Siudmiak – Studio Piękne Wnętrza.
              Dane przesłane w formularzu kontaktowym są przetwarzane wyłącznie w celu
              odpowiedzi na Twoją wiadomość lub nawiązania kontaktu.
            </p>

            <p>
              Masz prawo dostępu do swoich danych, ich poprawiania, usunięcia,
              ograniczenia przetwarzania oraz wniesienia skargi do UODO.
            </p>

            <p>
              Podanie danych jest dobrowolne, ale niezbędne do udzielenia odpowiedzi.
            </p>

            <button
              className="btn close-btn"
              onClick={() => setShowPolicy(false)}
            >
              Zamknij
            </button>
          </div>
        </div>
      )}
    </>
  );
}
